export enum EXTERNAL_LMS_SLUGS {
    MES = 'mes',
    DNEVNIKRU = 'dnevnikru'
}
